import dayjs from 'dayjs';
import { IInAppNotification, IGroupedNotifications } from '../interface/index';
import { NotificationTemplate } from '../interface/notification';
import { Briefcase, FilledDanger, FilledNote, Receipt } from '../components/icons';
import { FeatureSelectionTab } from '../interface/featureSelection';
import { TFunction } from 'i18next';

export const groupNotificationsByDay = (
  notifications: IInAppNotification[],
): IGroupedNotifications[] =>
  Object.values(
    notifications.reduce((acc: Record<string, IGroupedNotifications>, elem: IInAppNotification) => {
      const elemKey = dayjs(elem?.data?.notificationDateTime).format('DD');
      if (!acc[elemKey]) {
        acc[elemKey] = { date: elem?.data?.notificationDateTime, notifications: [] };
      }
      acc[elemKey]?.notifications.push(elem);
      acc[elemKey]?.notifications.sort(
        (a, b) =>
          new Date(b?.data?.notificationDateTime).valueOf() -
          new Date(a?.data?.notificationDateTime ?? a?.data?.createdAt).valueOf(),
      );
      return acc;
    }, {}),
  ).sort((a, b) => new Date(b?.date).valueOf() - new Date(a?.date).valueOf());

export const getNotificationIcon = (identifier: string) => {
  switch (identifier) {
    case NotificationTemplate.MATTER_OPENED:
      return <Briefcase />;
    case NotificationTemplate.CRITICAL_TASK_ALERT:
    case NotificationTemplate.CRITICAL_TASK_DUE:
      return <FilledDanger />;
    case NotificationTemplate.TASK_DUE:
    case NotificationTemplate.TASK_ALERT:
      return <FilledNote />;
    case NotificationTemplate.PRELIMINARY_INVOICE_APPROVAL:
    case NotificationTemplate.PRELIMINARY_INVOICE_REVIEW:
      return <Receipt />;
    default:
      return null;
  }
};
export const getSubDescriptionForFeatureRequired = (featureToEnable: number, t: TFunction) => {
  switch (featureToEnable) {
    case FeatureSelectionTab.transactions:
      return t('common:features.enableTransactionsFeaturePrompt');
    case FeatureSelectionTab.tasks:
      return t('common:features.enableTasksFeaturePrompt');
    case FeatureSelectionTab.workTimes:
      return t('common:features.enableWorkTimesFeaturePrompt');
    case FeatureSelectionTab.matters:
      return t('common:features.enableMattersFeaturePrompt');
    case FeatureSelectionTab.customers:
      return t('common:features.enableCustomersFeaturePrompt');
    case FeatureSelectionTab.invoicing:
      return t('common:features.enableInvoicingFeaturePrompt');
    default:
      return '';
  }
};
